import { Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClearanceItemAssetBaseComponent } from './clearance-item-asset-base.component';
import * as $ from 'jquery';
import { IAsset } from './asset.interface';

@Component({
    selector: 'clearance-document',
    template: require('./clearance-item-document.component.html')
})

export class ClearanceItemDocumentComponent extends  ClearanceItemAssetBaseComponent implements IAsset {

    setDefaultAssetImage() {
        throw new Error("Method not implemented.");
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/asset-management/clearance-item-document.component.ts